const indexItems = [
  { icon: 'ri-fire-line', label: '动作大片', desc: '燃爆肾上腺素', color: 'bg-primary-100 text-primary-600' },
  { icon: 'ri-emotion-happy-line', label: '喜剧天地', desc: '笑到停不下来', color: 'bg-accent-100 text-accent-600' },
  { icon: 'ri-heart-line', label: '爱情剧场', desc: '心动每一刻', color: 'bg-primary-100 text-primary-600' },
  { icon: 'ri-rocket-line', label: '科幻巨制', desc: '探索未知世界', color: 'bg-accent-100 text-accent-600' },
  { icon: 'ri-ghost-line', label: '恐怖悬疑', desc: '胆量极限挑战', color: 'bg-primary-100 text-primary-600' },
  { icon: 'ri-user-smile-line', label: '动漫世界', desc: '二次元狂欢', color: 'bg-accent-100 text-accent-600' },
  { icon: 'ri-slideshow-line', label: '纪录片', desc: '真实的力量', color: 'bg-primary-100 text-primary-600' },
  { icon: 'ri-tv-line', label: '国产剧集', desc: '追剧不等待', color: 'bg-accent-100 text-accent-600' },
  { icon: 'ri-global-line', label: '海外精选', desc: '全球好剧汇', color: 'bg-primary-100 text-primary-600' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              影视分类
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              全类型覆盖，快速找到你想看的内容
            </p>
          </div>

          <div className="grid grid-cols-3 md:grid-cols-3 lg:grid-cols-9 gap-3 md:gap-4">
            {indexItems.map((item) => (
              <a
                key={item.label}
                href="#media"
                className="group flex flex-col items-center gap-2 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300"
              >
                <div className={`w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-xl ${item.color}`}>
                  <i className={`${item.icon} text-lg md:text-xl`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors text-center whitespace-nowrap">
                  {item.label}
                </span>
                <span className="text-xs text-foreground-400 text-center hidden md:block">{item.desc}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}